var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('upgrade-tooltip',{attrs:{"action":"contact this freelancer"}},[_c('el-button',{attrs:{"type":_vm.isOnFreePlan ? 'info' : 'warning',"plain":""},on:{"click":_vm.sendMessage}},[_vm._v("Message")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }